<template>
  <div>
    <div class="row">
      <div class="person__details col-12 col-md-4">
        <span class="person__details__label">{{ $t('clinical.people.client_nr')}}:</span>
        <span class="person__details__description">{{ person.process_id || 'N/A' }}</span>
      </div>
      <div class="person__details col-12 col-md-4">
        <span class="person__details__label">{{ $t('clinical.people.city') }}:</span>
        <span class="person__details__description">{{ city || 'N/A' }} </span>
      </div>
    </div>
    <div class="row">
      <div class="person__details col-12 col-md-4">
        <span class="person__details__label">{{ $t('clinical.people.phone') }}:</span>
        <span class="person__details__description">{{ phone || 'N/A' }} </span>
      </div>
      <div class="person__details col-12 col-md-4">
        <span class="person__details__label">{{ $t('clinical.people.nif')}}:</span>
        <span class="person__details__description">{{ person.tax_number || 'N/A' }} </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    phone: function () {
      if (this.person) {
        if (this.person.phone) {
          return this.person.phone
        } else if (this.person.work_phone) {
          return this.person.work_phone
        } else if (this.person.mobile_phone) {
          return this.person.mobile_phone
        }
      }
      return null
    },
    address: function () {
      if (this.person && this.person.addresses.length) {
        let lastest = this.person.addresses[this.person.addresses.length - 1]

        return [lastest.line1, lastest.line2, lastest.city, lastest.postal_code].filter(field => field).join(', ').trim()
      }
      return null
    },
    city: function () {
      if (this.person) {
        let addressesWithCity = this.person.addresses
          .filter(address => address.city)
          .map(address => address.city)

        return addressesWithCity[addressesWithCity.length - 1]
      }
      return null
    }
  }
}
</script>
<style lang="scss" scoped>
.person__details {
  margin-bottom: 15px;
  &__label {
    margin-right: 5px;
  }

  &__description {
    font-weight: bold;
  }
}
</style>
